import {useWorkspaceId} from "joynt/hooks/useWorkspaceId";
import {useNodeData} from "joynt/hooks/useNodeData";

export function useWorkspacePlan(id) {
    const workspace = useWorkspaceId();
    const {workspace_plan} = useNodeData(workspace);
    return workspace_plan;
}